import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import Zawodnik from './Zawodnik';
import Elearning from './Elearning';
import Polityka from './Polityka';

const root = ReactDOM.createRoot(document.getElementById('root'));
const path = window.location.pathname.toLowerCase();
const isZawodnik = path === '/zawodnik' || path === '/zawodnik/';
const isElearning = path === '/elearning' || path === '/elearning/';
const isPolityka = path === '/polityka-prywatnosci' || path === '/polityka-prywatnosci/';

root.render(
  <React.StrictMode>
    {isZawodnik ? <Zawodnik /> : isElearning ? <Elearning /> : isPolityka ? <Polityka /> : <App />}
  </React.StrictMode>
);